import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { env } from '@/env'

export const Route = createFileRoute('/auth')({
  validateSearch: (search): Record<string, string> =>
    Object.fromEntries(Object.entries(search).filter(([, v]) => typeof v === 'string')) as Record<
      string,
      string
    >,
  component: AuthCallback,
})

function AuthCallback() {
  const search = Route.useSearch()
  useEffect(() => {
    if (!window.opener) return
    window.opener.postMessage(search, new URL(env.VITE_BASE_URL).origin)
    window.close()
  }, [search])
  return null
}
